export const LANDING_STUDENT_SUB_URL = {
  index: '',
  lessonSelection: 'lesson-selection',
};
